import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutTheProduction from "./sections/AboutTheProduction";
import ShowDetails from "./sections/ShowDetails";
import CastCrew from "./sections/CastCrew";
import MediaGallery from "./sections/MediaGallery";
import AudienceTestimonials from "./sections/AudienceTestimonials";
import ContactTicketPurchase from "./sections/ContactTicketPurchase";
import AboutTheComposer from "./sections/AboutTheComposer";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutTheProduction />
      <ShowDetails />
      <CastCrew />
      <MediaGallery />
      <AudienceTestimonials />
      <AboutTheComposer />
      <ContactTicketPurchase />
      <Footer />
    </div>;
}